export const dockingStates = {
    READY: 'dockingState/READY',
    IN_PROGRESS: 'dockingState/IN_PROGRESS',
    COMPLETE: 'dockingState/COMPLETE',
};

export const defaultDockSpeed = 'fast';
